import {omit} from 'lodash';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {RendererOf} from '../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {TeamModel} from '../../../../libs/shared/core/src/models/api/teamModel';
import {TeamAvatar} from '../../../../libs/shared/ui/src/components/avatar/teamAvatar';
import {PopoverTransferProps} from '../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {NavigationLineProps} from '../../common/navigation/navigationLine';
import {
  NavigationLineChevron,
  NavigationLineChevronProps,
} from '../../common/navigation/navigationLineChevron';
import {NavigationLineIcon} from '../../common/navigation/navigationLineIcon';
import {NavigationLineLabel} from '../../common/navigation/navigationLineLabel';
import {WorkspaceLineDropTarget} from './line/workspaceLineDropTarget';
import {WorkspaceLineMore, WorkspaceLineMoreProps} from './line/workspaceLineMore';
import {WorkspaceItemRefinedResultsIndicator} from './workspaceItemRefinedResultsIndicator';

/*
 * Props.
 */

export interface WorkspaceTeamItemProps
  extends NavigationLineProps,
    NavigationLineChevronProps,
    WorkspaceLineMoreProps {
  /** The team to display. */
  team: TeamModel;
  /** Should the team name be bold */
  isUnread?: boolean;
  /** Should the "more" button be rendered */
  renderMenu?: RendererOf<PopoverTransferProps>;
  shouldAlphabetizeWorkspace: boolean;
  shouldShowRefinedResultsIndicator: boolean;
}

/*
 * Style.
 */

const StyledLabelWrapperDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const StyledWorkspaceItemRefinedResultsIndicator = styled(WorkspaceItemRefinedResultsIndicator)`
  margin-left: 4px;
`;

/*
 * Component.
 */

/** Display a team as a P1 workspace line. */
export const WorkspaceTeamItem: FC<WorkspaceTeamItemProps> = (props) => (
  <WorkspaceLineDropTarget {...props} renderTooltip={() => props.team.name} workspaceDragItem={undefined}>
    <NavigationLineChevron {...props} />
    <NavigationLineIcon>
      <TeamAvatar team={props.team} size={VisualSizesEnum.SMALL} />
    </NavigationLineIcon>
    <NavigationLineLabel isUnread={props.isUnread} isTitle isEditingWorkspace={props.isEditingWorkspace}>
      <StyledLabelWrapperDiv>
        <Trans id="workspace-team-inboxes">Shared inboxes</Trans>
        {props.shouldShowRefinedResultsIndicator && <StyledWorkspaceItemRefinedResultsIndicator />}
      </StyledLabelWrapperDiv>
    </NavigationLineLabel>

    <WorkspaceLineMore
      // Omit isEditingWorkspaces to avoid showing a checkbox in the team inbox header
      {...omit(props, 'isEditingWorkspace')}
    />
  </WorkspaceLineDropTarget>
);
